import React from 'react'
import styled from 'styled-components'
import { Badge } from '@chakra-ui/react'

const Container = styled.div`
    width: 500px;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    @media screen and (max-width: 873px){
        flex-direction: column-reverse;
        height: 345px;
        min-width: 360px;
        width: 360px;
     };
     @media screen and (max-width: 450px){
        width: 260px;
     };
`;

const BadgeDiv = styled.div`
     width: 100%;
`

const WrapText = styled.section`
    display: flex;
    flex-direction: column;
    font-size: 13px;
    height: 130px;
    width: 350px;
    margin: 25px;
    justify-content: space-between;

    @media screen and (max-width: 873px){
        margin-left: 0px;
        margin-bottom: 31px;
        width: 219px;
     };
`

const ImageCard = styled.img`
    width: 50%;
    height: 50%;
    margin-top: 20px;
    margin-bottom: 20px;
    object-fit: cover;

    @media screen and (max-width: 873px){
        width: 50%;
        height: 50%;
        margin-top: 0px;
     };
     
`;


const Card = ({
    jabatan,
    perusahaan,
    durasi,
    lokasi,
    waktuPost, 
    logo,
    nominal}) => {
   
    return (
           <Container>
                <ImageCard src={logo}/>
                <WrapText>
                    <BadgeDiv>
                        {nominal !== null ? 
                            <Badge p={2} colorScheme='purple' fontSize='13px'>Biaya: {nominal}</Badge>
                        : 
                            <Badge p={2} colorScheme='purple' fontSize='13px'>Tidak dipungut biaya</Badge>
                        }
                    </BadgeDiv>
                   
                    <br></br>
                    <span style={{fontSize: '25px', fontWeight: '600'}}>{jabatan}</span>
                    <span style={{fontSize: '15px', fontWeight: '600'}}>{perusahaan}</span>
                    <span style={{fontSize: '15px', color: '#828282'}}>{durasi}</span>
                    <span style={{fontSize: '15px', color: '#828282'}}>{lokasi}</span>
                    <span style={{fontSize: '15px', color: '#0078CF'}}>Dipost {waktuPost} hari yang lalu</span>
                    
                </WrapText>
           
       </Container>
    )
}

export default Card
